import Vue from "vue";
import Vuex from "vuex";

// Modules
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import auth from "./auth/moduleAuth";
import user from "./user/moduleUser";
import library from "./library/moduleLibrary";
import modals from './modals/moduleModals';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    user,
    library,
    modals
  },
  strict: process.env.DEV,
});
